<template>
  <div>
    <div class="maineditor" v-if="doinitonload" v-bind:style="'height:' + height + 'px'">

      <editor ref="editor1" style="height:100%;" class="editorwrapper" apiKey="ean2nl7prjqb1unjkg6kltidatbm2xw31kalfemhvh3vw07n"
              :plugins="plugins"
              :toolbar="toolbar"
              :init="myInit"
              v-model="content" v-on:onInit="loaded" v-on:onChange="update">
      </editor>
    </div>
  </div>
</template>

<script>
  import Editor from '@tinymce/tinymce-vue'

  export default {
    name: 'mce-editor',
    components: {
      'editor': Editor
    },
    props: {
      method: { type: Function },
      value: { type: String, default: "" },
      toolbar: { type: String, default: "bold italic underline link image media code | bullist numlist" },
      plugins: { type: String, default: "link image imagetools media code lists" },
      height: { type: Number, default: 400 },
      name: { type: String, default: null },
      filefolder: { type: String, default: null },
      doinitonload: { type: Boolean, default: true },
    },
    data: function () {
      return {
        theme: "modern",
        myInit: null,
        content: this.value // default to the passed value
      }
    },
    data_old() {
      return {
        theme: "modern",
        myInit: null,
        content: this.value
      }
    },
    methods: {
      loaded() {
        
      },
      update() {
        this.value = this.content;
        this.$emit('input', this.content);
      },
      getId() {
        return this._uid;
      },
      initMCE() {
        this.doinitonload = true;
        this.$forceUpdate();
        this.$refs.editor1.$mount();
      },
      setValue(val) {
        this.content = val;
        //this.value = JSON.parse(JSON.stringify(val));
        //this.$forceUpdate();
      },
      getValue() {
        return JSON.parse(JSON.stringify(this.content));
      }
    },
    watch: {
      content: function (newVal, oldVal) {
        this.$emit('input', newVal);
      },
      value: function (newVal, oldVal) {
        this.content = newVal;
        //this.$emit('input', newVal);
        //this.$emit('change', val);
        //this.$forceUpdate();
      }
    },
    mounted() {

      var thisContext = this;

      this.myInit = {
        menubar: false,
        extended_valid_elements: 'i[class],em[class]',
        content_css: '/global_assets/css/icons/icomoon/styles.css,/global_assets/css/icons/fontawesome/styles.min.css,/assets/css/bootstrap.min.css,/assets/css/bootstrap_limitless.min.css,/assets/css/layout.min.css,/assets/css/components.min.css,/assets/css/colors.min.css,/global_assets/css/custom-style.css,/global_assets/css/custom-media.css,/css/custom-colors.css,/css/Themes.css',

        images_dataimg_filter: function (img) {
          return false;
          return img.hasAttribute('internal-blob');
        },
        keep_styles: false,
        convert_urls: false,
        height: this.height,
        automatic_uploads: true,
        images_upload_base_path: Vue.prototype.$hostname + "/api/upload/v1/upload",
        relative_urls: false,
        content_style: ".mce-content-body {padding-left: 5px; padding-right: 5px }",

        // override default upload handler to simulate successful upload
        images_upload_handler: function (blobInfo, success, failure, folderName) {
          var xhr, formData;
          xhr = new XMLHttpRequest();
          xhr.withCredentials = false;

          xhr.open('POST', Vue.prototype.$hostname + "/api/upload/v1/upload?filefolder=" + thisContext.filefolder);

          //xhr.setRequestHeader("X-CSRF-Token", token);

          xhr.onload = function () {
            var json;

            if (xhr.status != 200) {
              failure('HTTP Error: ' + xhr.status);
              return;
            }
            json = JSON.parse(xhr.responseText);

            if (!json || typeof json.url != 'string') {
              failure('Invalid JSON: ' + xhr.responseText);
              return;
            }
            success(json.url);

          };

          formData = new FormData();
          formData.append('file', blobInfo.blob(), blobInfo.filename());

          xhr.send(formData);

        },
        file_picker_callback: function (success, value, meta) {
          var input = document.createElement('input');
          input.setAttribute('type', 'file');
          input.setAttribute('accept', 'image/*');

          /*
            Note: In modern browsers input[type="file"] is functional without
            even adding it to the DOM, but that might not be the case in some older
            or quirky browsers like IE, so you might want to add it to the DOM
            just in case, and visually hide it. And do not forget do remove it
            once you do not need it anymore.
          */

          input.onchange = function () {

            var file = this.files[0];

            var reader = new FileReader();

            reader.onload = function () {
              var id = 'blobid' + (new Date()).getTime();
              var blobCache = tinymce.activeEditor.editorUpload.blobCache;
              var base64 = reader.result.split(',')[1];
              var blobInfo = blobCache.create(id, file, base64);
              blobCache.add(blobInfo);

              //We have read the file as a, now try to upload it

              var xhr, formData;
              xhr = new XMLHttpRequest();
              xhr.withCredentials = false;

              xhr.open('POST', Vue.prototype.$hostname + "/api/upload/v1/upload?filefolder=" + thisContext.filefolder);

              formData = new FormData();
              formData.append('file', blobInfo.blob(), blobInfo.filename());

              xhr.onload = function () {
                var json;

                if (xhr.status != 200) {
                  failure('HTTP Error: ' + xhr.status);
                  return;
                }
                json = JSON.parse(xhr.responseText);

                if (!json || typeof json.url != 'string') {
                  failure('Invalid JSON: ' + xhr.responseText);
                  return;
                }
                success(json.url);

              };

              xhr.send(formData);

            };

            reader.readAsDataURL(file);

          };

          input.click();

          /*
          // Provide file and text for the link dialog
          if (meta.filetype == 'file') {
            callback('mypage.html', { text: 'My text' });
          }
     
          // Provide image and alt text for the image dialog
          if (meta.filetype == 'image') {
            callback('myimage.jpg', { alt: 'My alt text' });
          }
     
          // Provide alternative source and posted for the media dialog
          if (meta.filetype == 'media') {
            callback('movie.mp4', { source2: 'alt.ogg', poster: 'image.jpg' });
          }
          */
        }
      }

      this.initMCE();
    }
  }
</script>

<style scoped>
  .editorwrapper{
    height:100%;
  }
</style>
<style>
  .tox-tinymce {
    height: 100% !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/mce/mce-editor.vue